import { Link } from "react-router-dom";
import { Video, ArrowRight, Clock, ShieldCheck } from "lucide-react";

export const SessionBooking = () => (
  <div id="session-booking" className="card-surface p-6 md:p-8 flex flex-col" data-testid="session-booking">
    <div className="text-xs uppercase tracking-[0.28em] text-amber-300/90 mb-2 inline-flex items-center gap-2">
      <Video size={13} aria-hidden="true" /> 1-on-1 with Gabi
    </div>
    <h3 className="font-display text-2xl md:text-3xl text-neutral-100 mb-2">Talk it through.</h3>
    <p className="text-sm text-neutral-400 mb-4">
      A 30-minute Google Meet with me as your recovery advocate. Come with your questions, your story, or
      just the thing you haven't said out loud yet.
    </p>
    <div className="font-display text-3xl text-amber-200 mb-5" data-testid="session-price">
      $45 <span className="text-sm text-neutral-500 font-sans">/ 30 min</span>
    </div>
    <ul className="space-y-2 text-sm text-neutral-300 mb-6 flex-1">
      <li className="flex items-center gap-2"><Clock size={14} className="text-teal-300" aria-hidden="true" /> Tue, Wed &amp; Thu · 10am–4pm Pacific</li>
      <li className="flex items-center gap-2"><Video size={14} className="text-teal-300" aria-hidden="true" /> Your own private Google Meet link</li>
      <li className="flex items-center gap-2"><ShieldCheck size={14} className="text-teal-300" aria-hidden="true" /> Pick your time and pay in one step</li>
    </ul>
    <Link to="/book" data-testid="session-book-btn" className="btn-primary w-full py-3 inline-flex items-center justify-center gap-2 text-sm">
      Book a Session <ArrowRight size={14} aria-hidden="true" />
    </Link>
    <p className="text-[11px] text-neutral-500 text-center mt-3">
      Peer support, not therapy or medical care.
    </p>
  </div>
);
